import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import styles from './Contact.module.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    quantity: '',
    message: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create WhatsApp message
    const whatsappMessage = `*New Inquiry from Website*
------------------------------
*Name:* ${formData.name}
*Phone:* ${formData.phone}
*Quantity:* ${formData.quantity}
*Message:* ${formData.message}
------------------------------`;

    const whatsappNumber = '919099099901';
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

    // Open WhatsApp
    window.open(whatsappUrl, '_blank');

    // Reset form
    setFormData({ name: '', phone: '', quantity: '', message: '' });
  };

  return (
    <div className={styles.contact}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>Contact Us</h1>
          <p className="gujarati-text">અમારો સંપર્ક કરો</p>
          <p className={styles.subtitle}>We'd Love to Hear From You</p>
        </div>
      </section>

      <section className={`${styles.contactSection} texture-bg`}>
        <div className="container">
          <div className={styles.contactGrid}>
            {/* Contact Info */}
            <motion.div
              className={styles.contactInfo}
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              {/* <h2>Get in Touch</h2>
              <p className="gujarati-text">સંપર્કમાં રહો</p> */}

              <div className={styles.infoCards}>
                <div className={styles.infoCard}>
                  <div className={styles.infoIcon}>
                    <FaMapMarkerAlt />
                  </div>
                  <div className={styles.infoText}>
                    <h4>Visit Our Farm</h4>
                    <p>JAY SHREE FARM HOUSE, OPP - MARKETING YARD</p>
                    <p>SHITAL PARK - 1, OPP - SURUCHI SCHOOL</p>
                    <p>KHAPAT, PORBANDAR - GUJARAT - 360575</p>

                  </div>
                </div>

                <div className={styles.infoCard}>
                  <div className={styles.infoIcon}>
                    <FaPhone />
                  </div>
                  <div className={styles.infoText}>
                    <h4>Call Us</h4>
                    <p>+91 90990 99901</p>
                    <p className={styles.timing}>Mon - Sat: 9 AM - 7 PM</p>
                  </div>
                </div>

                <div className={styles.infoCard}>
                  <div className={styles.infoIcon}>
                    <FaEnvelope />
                  </div>
                  <div className={styles.infoText}>
                    <h4>Email Us</h4>
                    <p>bahariyafood91@yahoo.com</p>
                  </div>
                </div>

                <div className={`${styles.infoCard} ${styles.whatsappCard}`}>
                  <div className={styles.infoIcon}>
                    <FaWhatsapp />
                  </div>
                  <div className={styles.infoText}>
                    <h4>WhatsApp</h4>
                    <p>Quick Response on WhatsApp</p>
                    <a
                      href="https://wa.me/919099099901"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.whatsappBtn}
                    >
                      <FaWhatsapp /> Chat Now
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div
              className={styles.contactForm}
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className={styles.formContainer}>
                <h2>Send Us a Message</h2>
                <p className="gujarati-text">અમને સંદેશ મોકલો</p>

                <form onSubmit={handleSubmit}>
                  <div className={styles.formGroup}>
                    <label htmlFor="name">
                      Your Name <span className="gujarati-text">(તમારું નામ)</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                    />
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="phone">
                      Phone Number <span className="gujarati-text">(ફોન નંબર)</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 98765 43210"
                      required
                    />
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="quantity">
                      Quantity Needed <span className="gujarati-text">(જરૂરી જથ્થો)</span>
                    </label>
                    <select
                      id="quantity"
                      name="quantity"
                      value={formData.quantity}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select quantity</option>
                      <option value="250ml">250ml</option>
                      <option value="500ml">500ml</option>
                      <option value="1000ml">1000ml (1L)</option>
                      <option value="bulk">Bulk Order</option>
                    </select>
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="message">
                      Message <span className="gujarati-text">(સંદેશ)</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Any special requirements or questions..."
                      rows="5"
                    ></textarea>
                  </div>

                  <button type="submit" className={styles.submitBtn}>
                    Send Message
                  </button>
                </form>
              </div>
            </motion.div>
          </div>

          {/* Map Section */}
          <div className={styles.mapSection}>
            <h2>Find Us on Map</h2>
            <p className="gujarati-text">નકશા પર અમને શોધો</p>
            <div className={styles.mapContainer}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1778474447213!6m8!1m7!1s8v0IFotb-eCwWpIl_-SCmw!2m2!1d21.65263831489813!2d69.62803508322912!3f29.93141836462866!4f0!5f0.7820865974627469" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: '20px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Bahariya Farm Location - Porbander"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
